import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import Header from '../components/Header';
import '../Materials.css';

const MaterialDetail = () => {
    const { id } = useParams();
    const [material, setMaterial] = useState(null);

    useEffect(() => {
        fetch('https://ems.lexikonn.eu/api/get_materials.php')
            .then(res => res.json())
            .then(data => {
                const found = data.find(m => m.id == id);
                if (found) setMaterial(found);
            });
    }, [id]);

    if (!material) return <div className="container py-5">Načítám...</div>;

    return (
        <div className="container py-5">
            <Header/>
            <Link to="/materialy" className="btn btn-secondary mb-3">Zpět na seznam</Link>
            <h2>{material.title}</h2>
            <div dangerouslySetInnerHTML={{__html: material.text.replace(/\n/g, "<br />")}}/>
            <Link to="/materialy" className="btn btn-secondary mt-3">Zpět na seznam</Link>
        </div>
    );
};

export default MaterialDetail;
